<template>
  <form data-abide2 novalidate data-vv-scope="form4" @submit.prevent="submitForm" dusk="registration-step-4" class="step"  :style="{'justify-content':buttonToTop ? 'flex-start' : 'center','flex-flow' : buttonToTop ? 'column' : 'wrap'}">
    <div class="form-inner">
      <div class="headline" v-html="trans('reg.choose_password')"></div>
      <!-- Password needed for saving credentials in browser -->
      <input style="position: absolute;opacity: 0;z-index: -1" dusk="password" autocomplete="current-password" type="password" name="password" :value="password" />
      <label class="password-container">
        <input class="form-control dark"
               :type="showpassword ? 'text' : 'password'"
               ref="password_input"
               id="password"
               v-bind:placeholder="trans('password')"
               v-bind:data-vv-as="trans('password').toLowerCase()"
               required
               v-model="password"
               v-validate="'required|min:6'"
               :class="{'is-invalid-input': errors.has('form4.password')}"
               name="password" />
        <div @click="showpassword = !showpassword" class="hide-password" :class="{'show' : !showpassword}"></div>
        <p v-if="!password" class="text-mute">{{trans('reg.password_description')}}</p>
        <p class="text-mute password-success" v-if="password !== '' && !errors.has('form4.password')">{{trans('reg.password_looks_good')}}</p>
        <span class="form-error" :class="{'is-visible': errors.has('form4.password')}">
            {{ errors.first('form4.password') }}
          </span>
      </label>
    </div>
    <div class="form-footer">
      <button :disabled="!password || errors.has('form4.password')" class="btn btn-primary btn-long btn-rounded" id="button4" type="submit">
        {{ trans('reg.finish') }}
      </button>
    </div>
  </form>
</template>

<script>
import DatePickerComponent from '@buddy/views/widgets/DatePickerComponent.vue';
import _ from "lodash";
import { VueReCaptcha } from 'vue-recaptcha-v3'
export default {
  mixins: [require('@general/lib/mixin').default],
  props: ['vars'],
  data() {
    return this.vars;
  },
  components: {
    DatePickerComponent,
    VueReCaptcha
  },
  methods: {

    async recaptcha() {
      await this.$recaptchaLoaded()

      return await this.$recaptcha('login')
    },

    decode : function () {
      const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      let input = document.head.querySelector("[name=hash][content]").content;
      let input_secret = document.head.querySelector("[name=hash_secret][content]").content;
      var n = input_secret.slice(-1);
      let index = input_secret.length;
      input = input.substring(0, index-1) + n + input.substring(index);
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      let utftext = output;
      var string = "";
      var i = 0;
      let c = 0;
      let c1 = 0;
      let c2 = 0;
      let c3 = 0;
      while ( i < utftext.length ) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        }
        else if((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i+1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        }
        else {
          c2 = utftext.charCodeAt(i+1);
          c3 = utftext.charCodeAt(i+2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    },
    async submitForm(e) {
      e.preventDefault();

      this.showLoadingButton('#button4')

      let response = await axios.post('/api/register/validate-password', {password: this.password})
      if (response.data.success) {
        if(this.location_type === 'error'){
          try{
            let response = await axios.post('/api/register/find-location')
            if (response.status === 200) {
              this.country_code = response.data.country_code;
              this.locality = response.data.locality;
              this.state = response.data.state;
              this.country = response.data.country;
              this.lat = response.data.lat;
              this.lng = response.data.lng;
              this.address = response.data.address;
              this.location_type = 'manual';
            }
          }catch (e){
            this.location_type = 'manual';
            this.step = 'locality';
            this.mapVisible = true;
            if(this.addressError){
              this.addressShow = this.trans('reg.location_defining');
              this.addressError = '';
              if(this.address){
                this.addressShow = this.address;
              }
            }
            this.restoreLoadingButton('#button4')
            return false;
          }
        }
        let campaigns_list = [
          'barebuddy'
        ];
        let campaign = null;
        $.each(campaigns_list,function (key,val){
          if(window.location.href.indexOf(val) !== -1){
            campaign = val;
          }
        })
        const token = await this.recaptcha();
        this.decode();
        let offsetMinutes = new Date().getTimezoneOffset();

        // переводим в часы и меняем знак
        let utcOffset = -offsetMinutes / 60;
        let data = {
          handle: this.handle,
          email: this.email,
          password: this.password,
          dob: this.dob,
          headline: this.nickname,
          terms: this.acceptTerms,
          honeypot: this.honeypot.value,
          lang: app.lang,
          registered_via: 'buddy-vue-web',
          lat: this.lat,
          lng: this.lng,
          address: this.address,
          country: this.country,
          country_code: this.country_code,
          location_type: this.location_type,
          locality: this.locality,
          state: this.state,
          recaptcha: token,
          key: this.decode(),
          timezone_utc: 'UTC' + (utcOffset.toString().indexOf('-') === 0 ? '' : '+') + utcOffset.toString()
        }

        try{
          data['timezone'] =  Intl.DateTimeFormat().resolvedOptions().timeZone;
        }catch (e){

        }
        if(campaign){
          data.campaign = campaign;
        }

        if (this.avatarPhoto) {
          data.photo = this.avatarPhoto
          data.actions = JSON.stringify(this.avatarActions)
        }

        let formData = this.getFormData(data)
        try {
          let response = await axios.post('/api/register/validateAndRegister', formData)
          if (response.status === 200) {
            //after getting data and till reloading page button must be in loading mode
            //this.showLoadingButton('#button4')

            await auth.login(this.email, this.password)

            if (app.isDesktop) {
              this.step = 'welcome';
            }else{
              window.history.pushState({'id': 1}, '/welcome', '/welcome');
              window.location.reload();
            }
          }
        } catch (error) {
          let errorFields = error.data.fields
          if (_.intersection(errorFields, ['email', 'password', 'dob']).length !== 0) {
            this.step = 1;
            return false;
          } else if (_.intersection(errorFields, ['photo']).length !== 0) {
            this.step = 2;
            return false;
          } else if (_.intersection(errorFields, ['terms', 'captcha']).length !== 0) {
            this.step = 3;
            return false;
          }

          if (error.status === 422) {
            this.showErrorNotification(error.data.error)
          }
          if (error.data.error === 'maintenance_mode') {
            this.showErrorNotification(error.data.message)
          }
          this.restoreLoadingButton('#button4')
        }
      }else{
        this.restoreLoadingButton('#button4')
        this.errors.add({
          field: 'form5.password',
          msg: response.data.errors.password[0]
        });
        let emailError = function(e){
          this.errors.clear();
          document.getElementById('button4').removeEventListener('click', emailError);
        }
        document.getElementById('button4').addEventListener('keyup', emailError);
      }
    },
  },
  mounted() {
    let password = document.getElementById('password');

    let self = this;
    if(this.isMobile){
      password.addEventListener("focus", () => {
        self.buttonToTop = true;
      })
      password.addEventListener("blur", () => {
        self.buttonToTop = false;
      })
      document.getElementById('button4').addEventListener('touchend', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(!(!this.password || this.errors.has('form4.password'))){
          this.submitForm(e)
        }
      });
    }

    if(this.buttonToTop || this.isDesktop){
      this.$nextTick(() => this.$refs.password_input.focus())
    }
  },
}
</script>